import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import DashboardHeader from './DashboardHeader';
import Footer from './Footer';
import CompanyModal from './CompanyModal';
import { useCompany } from '../context/CompanyContext';

function PageLayout({ children }) {
  const { toast } = useCompany();
  const [navOpen, setNavOpen] = useState(false);
  const location = useLocation();

  // Tapping a menu item on a phone navigates but leaves the drawer sitting
  // over the page it just opened, so close it whenever the route changes.
  useEffect(() => {
    setNavOpen(false);
  }, [location.pathname]);

  return (
    <div className="dash-layout">
      <Sidebar open={navOpen} />
      {navOpen && (
        <div
          className="dash-nav-backdrop"
          onClick={() => setNavOpen(false)}
          aria-hidden="true"
        />
      )}
      <div className="dash-main">
        <DashboardHeader onMenuClick={() => setNavOpen((o) => !o)} />
        <div className="dash-content">{children}</div>
        <Footer />
      </div>
      {toast && <div className="cal-toast">{toast}</div>}
      <CompanyModal />
    </div>
  );
}

export default PageLayout;
